<template>
	<div id="app">
		<nav-bar @menu-button-click="toggleSideBar"/>
		<div class="main-container">
			<side-bar :hidden="sideBarHidden" />

			<keep-alive exclude="ConteudoCardLocalizacao">
				<router-view></router-view>
			</keep-alive>

		</div>
	</div>
</template>

<script>
	import NavBar from "./components/NavBar.vue";
	import SideBar from "./components/SideBar.vue";


	export default {
		name: "App",
		components: { SideBar, NavBar},
		data () {
			return {
				sideBarHidden: true
			};
		},

		methods: {
			toggleSideBar () {
				this.sideBarHidden = !this.sideBarHidden;
			}
		}
	};
</script>

<style scoped>
#app {
	height: 100vh;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.main-container {
	display: flex;
	flex: 1;
	overflow: hidden;
	position: relative;

}
</style>
